class ReadMoreDescription extends window.BAO.CustomElement() {
  static get requiredAttributes () {
    return [
      'data-read-more-description-short-content-visible',
      'data-read-more-description-translation-read-more',
      'data-read-more-description-translation-read-less',
    ]
  }

  static get requiredElements () {
    return ['trigger']
  }

  setupListeners () {
    super.setupListeners()
    this.listeners.add(this, 'click', this.handleClick.bind(this))
  }

  handleClick (event) {
    if (!event.target.closest(this.els.trigger.selector)) return
    const shortContentVisible =
      this.dataset.readMoreDescriptionShortContentVisible === 'true'
    this.setAttribute(
      'data-read-more-description-short-content-visible',
      String(!shortContentVisible),
    )

    this.els.trigger.element.textContent = !shortContentVisible
      ? this.dataset.readMoreDescriptionTranslationReadMore
      : this.dataset.readMoreDescriptionTranslationReadLess
  }
}

if (!customElements.get('read-more-description')) {
  customElements.define('read-more-description', ReadMoreDescription)
}
